import React from 'react';
const links = [{
  label: 'Terms',
  href: '#terms'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Refund Policy',
  href: '#refund'
}];
export function SiteFooter() {
  return <footer className="bg-brand-charcoal px-5 pb-28 pt-12 text-white/70 md:pb-12 lg:px-8" data-id="element-142" data-mp="35dsmhxfh8kqu">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-143" data-mp="3a4r91er26f2j">
        <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-white" data-id="element-144" data-mp="3f4x1uy92e7m7">
          Makeup Instructor Ready
        </p>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-145" data-mp="3k1drjwvwwu1e">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60" data-id="element-146" data-mp="3t3myydvvw7ak">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-white/50" data-id="element-147" data-mp="5hms3q035o46">
        © 2026 Makeup Instructor Ready. A digital educational resource system delivered as non-editable PDFs.
        It does not represent government licensing or external accreditation. Payments are processed in your
        local currency.
      </p>
    </footer>;
}